import { useEffect, useState } from 'react'
import { useIsHydrating, useIsScreenLoading } from '@muse-web/router'

import {
    RouteProgressBar,
    type TRouteProgressPhase,
} from '../components/route-progress-bar/RouteProgressBar'

const FADE_OUT_MS = 300

const resolvePhase = (isLoading: boolean, hasSettled: boolean): TRouteProgressPhase => {
    if (isLoading) {
        return 'loading'
    }

    return hasSettled ? 'idle' : 'done'
}

export const RouteProgressContainer = () => {
    const isHydrating = useIsHydrating()
    const isScreenLoading = useIsScreenLoading() && !isHydrating
    const [hasSettled, setHasSettled] = useState(true)

    useEffect(() => {
        if (isScreenLoading) {
            setHasSettled(false)

            return undefined
        }

        if (hasSettled) {
            return undefined
        }

        const timer = setTimeout(() => setHasSettled(true), FADE_OUT_MS)

        return () => clearTimeout(timer)
    }, [isScreenLoading, hasSettled])

    return <RouteProgressBar phase={resolvePhase(isScreenLoading, hasSettled)} />
}
